import NodeRSA from 'node-rsa';
export function encryptData(data, publicKey) {
    console.log("---encryptData", data)
    if(!data) return;
    if(!publicKey) return;
    //创建公钥实例
    const pubKey = new NodeRSA(publicKey, 'pkcs8-public');
    pubKey.setOptions({
        encryptionScheme: 'pkcs1',
      }); // 设置加密选项：确保加密方案与 Java 加密一致。
      // 加密后的参数
    const encrypted = pubKey.encrypt(data, 'base64');
    return encrypted;
}